import { render } from "./pendingList.vue?vue&type=template&id=0d7ab208"
import script from "./pendingList.vue?vue&type=script&lang=js"
export * from "./pendingList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__